import React, { useEffect, useState } from "react";
import { Col, Row, Button, CardText, CardTitle, Label } from "reactstrap";
import NumberFormat from "react-number-format";
import Card from "reactstrap/es/Card";
import CardBody from "reactstrap/es/CardBody";
import {
	CurrencyDisplayElement,
	DateDisplayElement,
} from "../features/deal/components/DisplayElement";
import ReactTable from "../components/tables/ReactTable";
import FilterColumn from "../utils/filterColumn";
import dayjs from "dayjs";
import { getPayemntsByDateRange, updateTrackStatus } from "./AccountAPI";
import { useFromUser } from "../stores/LocalStorageHelper";
import InputElement, {
	CheckBoxElement,
} from "../features/forms/components/InputElement";

const AcctTrackPayments = () => {
	const locationID = useFromUser("locationID");

	const [paymentTrack, setPaymentTrack] = useState(false);
	const [payments, setPayments] = useState([]);
	const [fromDT, setFromDT] = useState(dayjs().format("YYYY-MM-DD"));
	const [toDT, setToDT] = useState(dayjs().format("YYYY-MM-DD"));

	const [showAdd, setShowAdd] = useState(false);
	const handleTrackChange = (paymentId, isChecked) => {
		// Optimistically update the local state
		const updatedPayments = payments.map((p) =>
			p.id === paymentId ? { ...p, track: isChecked } : p
		);
		setPayments(updatedPayments);

		// Send update to backend
	};
	const saveTrackUpdates = () => {
		const trackUpdates = payments.map(({ id, track }) => ({
			id,
			track: track === null ? false : track,
		}));

		// Call backend API with list of updates
		updateTrackStatus(trackUpdates)
			.then(() => {
				alert("Track updates saved successfully!");
			})
			.catch((err) => {
				console.error(err);
				alert("Failed to save track updates.");
			});
	};
	const shortColumns = [
		{
			Header: "#",
			accessor: (row, index) => index + 1,
		},
		{
			Header: "Track",
			accessor: "track",
			Cell: ({ row, value }) => (
				<CheckBoxElement
					disableValidation
					checked={!!value}
					onChange={(e) => handleTrackChange(row.original.id, e.target.checked)}
				/>
			),
		},
		{
			Header: "PMT_Date",
			accessor: "datePaid",
			Cell: ({ value }) => <DateDisplayElement val={value} />,
		},
		{
			Header: "PMT_Type",
			accessor: "pmtType",
			Filter: FilterColumn,
			filter: "includes",
		},
		{
			Header: "Receipt#",
			accessor: "receiptNo",
		},
		{
			Header: "Amount",
			accessor: "amtPaid",
			Cell: ({ value }) => <CurrencyDisplayElement val={value} />,
		},
		{
			Header: "Method",
			accessor: "method",
		},
		{
			Header: "Account Status",
			accessor: "acctSubStatus",
			Filter: FilterColumn,
			filter: "includes",
		},
		{
			Header: "Account Number",
			accessor: "acctNumber",
		},
		{
			Header: "Full Name",
			accessor: "buyerFullName",
		},
		{
			Header: "Cashier",
			accessor: "cashier",
		},
		{
			Header: "Credit-On",
			accessor: "creditOn",
			Cell: ({ value }) => <DateDisplayElement val={value} />,
		},
	];
	const [total, setTotal] = useState(0);
	const getTotals = (data) => {
		let total = 0;
		data.forEach((item) => {
			total += parseFloat(item.amtPaid);
		});
		setTotal(total);
		return total;
	};
	const handleFilteredDataChange = (visibleRows) => {
		const visibleData = visibleRows.map((r) => r._original || r);
		getTotals(visibleData);
	};
	useEffect(() => {
		getPayemntsByDateRange(
			locationID,
			dayjs(fromDT).format("MM/DD/YYYY"),
			dayjs(toDT).format("MM/DD/YYYY")
		).then(
			(res) => {
				setPayments(res.data.content);
				getTotals(res.data.content);
			},
			(err) => {
				if (!err.isGeneralError) {
					showApiError(err, retrieveFailAlert);
				}
			}
		);
		setPaymentTrack(false);
		// eslint-disable-next-line
	}, [paymentTrack]);

	return (
		<div>
			<div className="col-md-12 px-0 content">
				<Card>
					<CardTitle tag="h3" className="text-center">
						Payments Tracking
					</CardTitle>
					<Row>
						<InputElement
							disableValidation={true}
							value={fromDT}
							// onBlur={handleFromDateBlur}
							onChange={(e) => setFromDT(e.target.value)}
							name="fromDate"
							label="From Date"
							type="date"
							colSize="col-md-2 col-lg-2 mb-0 col-sm-2"
						/>
						<InputElement
							disableValidation={true}
							value={toDT}
							// onBlur={handleToDateBlur}
							onChange={(e) => setToDT(e.target.value)}
							name="toDate"
							label="To Date"
							type="date"
							colSize="col-md-2 col-lg-2 mb-0 col-sm-2"
						/>
						<Col xs="12" md="4">
							<Button
								color="primary"
								onClick={() => {
									setPaymentTrack(true);
								}}
							>
								<i className="nc-icon nc-cloud-download-93"></i> Update List
							</Button>
						</Col>
					</Row>

					{/* <Col xs="12" md="3">
						<Button
							color="primary"
							onClick={() => {
								saveTrackUpdates();
							}}
							buttonClass="btn btn-sm btn-link mx-auto"
						>
							<i className="nc-icon"></i> Save Tracking
						</Button>
					</Col> */}

					<CardBody>
						<ReactTable
							// onRowClick={onRowClick}
							data={payments}
							columns={shortColumns}
							onFilteredDataChange={handleFilteredDataChange}
						/>
					</CardBody>
				</Card>

				<Card>
					<CardBody>
						<Row>
							<Col sm="4">
								<CardText tag="h3" className="text-center">
									Total Payments
								</CardText>
							</Col>
							<Col sm="4">
								<CardText tag="h3" className="text-center">
									<NumberFormat
										thousandSeparator={true}
										decimalScale={2}
										fixedDecimalScale={true}
										prefix={"$"}
										isNumericString={true}
										readOnly={true}
										displayType="text"
										value={total === 0 ? "0" : total}
									/>
								</CardText>
							</Col>
							<Col xs="12" md="4">
								<Button
									color="primary"
									onClick={() => {
										saveTrackUpdates();
									}}
									size="md"
								>
									<i className="nc-icon nc-cloud-download-93"></i> Save Track
								</Button>
							</Col>
						</Row>
					</CardBody>
				</Card>
			</div>
		</div>
	);
};
export default AcctTrackPayments;
